import React from 'react';
import './App.css';
import RandomQuoteMachine from './RandomQuoteMachine';

function App() {
  return (
    <div className="App">
      <RandomQuoteMachine />
    </div>
  );
}

export default App;
